import APIObject from '../object'
import Enum from '../enums'

import Employee from './employee'

export default class ServiceResource extends APIObject {
  objectID () {
    return this.idServiceResource
  }

  relations () {
    return {
      assignment: { type: ServiceResourceAssignment },
      type: { type: ServiceResourceType },
      defaultSelection: { type: ServiceResourceDefaultSelection },
      resources: { type: Employee }
    }
  }

  get isDefaultSelectionNone () {
    return this.defaultSelection === ServiceResourceDefaultSelection.none
  }

  get isDefaultSelectionFirstAvailable () {
    return this.defaultSelection === ServiceResourceDefaultSelection.firstAvailable
  }

  get isAssignmentReservation () {
    return this.assignment === ServiceResourceAssignment.reservation
  }

  get isAssignmentCustomer () {
    return this.assignment === ServiceResourceAssignment.customer
  }
}
export const ServiceResourceAssignment = new Enum({
  reservation: { value: 0, description: 'Reservation' },
  customer: { value: 1, description: 'Customer' }
})

export const ServiceResourceType = new Enum({
  resource: { value: 0, description: 'Resource' },
  resourceType: { value: 1, description: 'Group' }
})

export const ServiceResourceDefaultSelection = new Enum({
  none: { value: -1, description: 'None (Optional)' },
  firstAvailable: { value: 0, description: 'First Available (Automatic)' }
})
